export default api => {
  return {
    async listBusinessEmails(params = { limit: 1000 }) {
      const { data } = await api.get(`/api/v3/business-emails`, { params })
      return data
    },
  }
}
